<template>
  <div v-if="badgeVariant" class="job-status">
    <div :class="'job-status--bg job-status--bg--' + badgeVariant" >
      <div :class="'job-status--' + badgeVariant" v-b-tooltip :title="statusTitle"></div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'job-status',
    props: ['jobStatusId'],
    computed: {
      statusTitle() {
        switch(parseInt(this.jobStatusId)) {
          case 11: return this.$t('printers.job.status.queue'); // in queue
          case 15:
          case 21: return this.$t('printers.job.status.progress');
          case 33:
          case 35: return this.$t('printers.job.status.pause');
          case 41: return this.$t('printers.job.status.failedStreaming');
          case 43: return this.$t('printers.job.status.failed');
          case 45:
          case 47: return this.$t('printers.job.status.aborted');
          case 57: return this.$t('printers.job.status.failedSuspiciousActivity');
          case 77: return this.$t('printers.job.status.finished');
          default: return this.$t('printers.job.status.unknown');
        }
      },

      badgeVariant() {
        switch (parseInt(this.jobStatusId)) {
          case 11: return ''; // in queue -yellow
          case 15:
          case 21: return '-blue badge--progress status';
          case 33:
          case 35: return 'pause';
          case 41: return 'issue';
          case 43:
          case 57: return 'issue';
          case 45:
          case 47: return 'canceled';
          case 77: return 'finished';
          default: return '-gray';
        }
      }
    }
  }
</script>

<style lang="scss">

  @import "../../../scss/theme";

  .job-status {
    position: relative;

    &--bg {
      display: block;
      height: 16px;
      width: 16px;
      position: absolute;
      background-color: white;
      border-radius: $s-x-small-border-radius;
      top: 7px;
      left: -12px;
      &--finished {
        background-color: #78b13f;
      }
      &--canceled {
        background-color: #333;
      }
      &--issue {
        background-color: #FAA911;
      }
    }

    &--issue {
      width: 0;
      height: 0;
      position: relative;
      top: 4px;
      left: 4.4px;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 8px solid white;
    }

    &--canceled {
      &:before, &:after {
        content: ' ';
        position: absolute;
        top: 3px;
        left: 7.4px;
        height: 10px;
        width: 2px;
        background-color: white;
      }
      &:before {
        transform: rotate(45deg);
      }
      &:after {
        transform: rotate(-45deg);
      }

    }

    &--play {  //unfinished
      width: 0;
      height: 0;
      border-top: 4px solid transparent;
      border-left: 6px solid #000;
      border-bottom: 4px solid transparent;
    }

    &--pause {
      position: relative;
      width: 6px;
      height: 8px;
      top: 4.2px;
      left: 5.2px;
      border-right: 2px solid #000;
      border-left: 2px solid #000;
    }

    &--finished {
      position: relative;
      top: 2px;
      left: 5px;
      transform: rotate(45deg);
      height: 10px;
      width: 6px;
      border-bottom: 2.4px solid white;
      border-right: 2.4px solid white;
    }
  }


</style>